import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddCompetitors({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer 
    pageName={'Add Competitors'}  
    email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />
    )
}

